<template>
  <div
    class="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-white text-center offline-mode"
  >
    <header class="offline-header w-100">
      <img
        src="@/assets/logo.svg"
        alt="Energielenker Connect"
        class="offline-logo-header"
      >
    </header>

    <div class="offline-content mt-5">
      <p class="fw-bold mb-3">
        {{ $t('offline.headline') }}
      </p>

      <p class="lead mb-4 px-3">
        {{ $t('offline.message') }}
      </p>

      <img
        src="@/assets/icons/maintenance.svg"
        alt="Wartung"
        class="offline-img mb-4"
      >

      <button
        class="btn btn-reload d-flex align-items-center justify-content-center mx-auto"
        @click="reloadPage"
      >
        <img
          src="@/assets/icons/reload.svg"
          alt="Neu laden"
          class="reload-icon me-2"
        >
        {{ $t('common.reload') }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useSystemStore } from '@/stores/systemStore';
import apiClient from '@/services/axios';

export default defineComponent({
  name: 'OfflineModeComponent',
  setup() {
    const systemStore = useSystemStore();

    async function pingBackend(): Promise<boolean> {
      try {
        await apiClient.get('/'); 
          return true;
      } catch {
          return false;
      }
    }
    const reloadPage = async () => {
      const isBackendUp = await pingBackend();
      if (isBackendUp) {
        systemStore.deactivateMaintenance();
      } else {
        console.warn('Backend still down');
      }
    };

    return { 
      reloadPage 
    };
  },
});
</script>

<style scoped>
.offline-mode {
  z-index: 999999;
  backdrop-filter: blur(4px);
  padding: 1rem;
  overflow-y: auto;
}

.offline-header {
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  border-bottom: 1px solid #e0e3e5;
  padding: 1.25rem 0;
  text-align: center;
}

.offline-logo-header {
  max-width: 300px;
}

.offline-content {
  margin-top: 5rem;
  max-width: 320px;
}

.offline-img {
  max-width: 300px;
}

.btn-reload {
  background-color: #7190a6;
  color: #fff;
  border: none;
  padding: 0.875rem 2rem;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  width: 300px;
  transition: background-color 0.2s ease;
  border: #325f80 1px solid;
}

.btn-reload:hover {
    background: #eef2f4;
    border: #325f80 1px solid;
    color: rgb(50, 95, 128);
    .reload-icon {
    filter: brightness(0) saturate(100%) invert(53%) sepia(20%) saturate(542%) hue-rotate(162deg) brightness(100%) contrast(84%);
    }
}

.reload-icon {
  width: 1.2rem;
}

.lead{
    font-weight: 400;
    font-size: 1rem;
}
</style>
